import { HttpServiceResponse } from '../../shared'
import { AccountViewPages } from '../models/account.types'
import { AccountViewParams } from '../models/view-params.model'
import AbstractAccountProvider from './account-abstract.provider'

export class AccountViewProvider extends AbstractAccountProvider {
  urlPath = 'acc_account_view_api'

  public view<T>(page: AccountViewPages, params: Partial<AccountViewParams>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      page,
      ...params,
    })

    return this.http.get(`${this.url}?${query}`)
  }
}
